import { Fragment, useEffect } from 'react';
import PropTypes from 'prop-types';
import styles from './ProductAction.module.scss';
import { scrollTo, getDateStatus } from '../utility';
import { getLowestPrice } from './ProductHelper';
import FavoriteButton from '../FavoriteButton';
import ProductCoupon from './ProductCoupon';
import Button from '@polydice/ui/dist/Button';
import classNames from 'classnames';
import { triggerSimpleDialog } from '@polydice/ui/dist/Dialog';

const ProductAction = ({
  searchMode,
  product,
  favoriteEndpoint,
  isFavorite,
  user,
  coupon,
  fundraisingMode,
  darkMode
}) => {
  const { skus, started_at, ended_at } = product;
  const dateStatus = getDateStatus(started_at, ended_at);
  const unableToBuy = fundraisingMode && dateStatus !== 'active';

  const handleScroll = () => {
    const element = document.getElementById('buy-options-start');
    scrollTo(element);
    setTimeout(() => scrollTo(element), 600);
  };

  const openSoldOutDialog = () => {
    triggerSimpleDialog({
      title: '已下架',
      focusDomSelector: '[name=button]',
      withCloseIconButton: true,
      children: (
        <div>
          此商品已售完，感謝大家的支持！
          <a
            href="https://market.icook.tw/categories/33"
            style={{ color: 'dodgerblue' }}
          >
            點此逛逛更多熱銷商品
          </a>
        </div>
      )
    });
  };

  useEffect(() => {
    if (dateStatus === 'expired') {
      openSoldOutDialog();
    }
  }, [dateStatus]);

  return (
    <section
      className={classNames(styles.productAction, {
        'dark-mode no-border': darkMode
      })}
    >
      {coupon && coupon.vip_only && (
        <div className={styles.productActionCoupon}>
          <i
            className={`icon-coupon-regular ${styles.productActionCouponIcon}`}
          />
          <ProductCoupon user={user} coupon={coupon} />
        </div>
      )}
      <div
        className={classNames(styles.productActionContainer, {
          [styles.productActionContainerFundraising]: fundraisingMode,
          'dark-mode gray2-bgc': darkMode
        })}
      >
        {dateStatus !== 'expired' &&
          !searchMode &&
          !fundraisingMode &&
          skus.length !== 0 && (
            <Fragment>
              <span
                className={classNames(styles.productActionContainerLowerPrice, {
                  'dark-mode gray2-bgc': darkMode
                })}
              >
                最低價
              </span>
              <span
                className={classNames(styles.productActionContainerPrice, {
                  'dark-mode gray2-bgc': darkMode
                })}
              >
                NT$ {getLowestPrice(product)}
                <small>起</small>
              </span>
            </Fragment>
          )}
        <div
          className={classNames(styles.productActionContainerButton, {
            'dark-mode gray2-bgc': darkMode
          })}
        >
          <Button
            styleType="contained"
            color="primary"
            onClick={handleScroll}
            disabled={unableToBuy || dateStatus === 'expired'}
            className={classNames({ 'dark-mode blue-button': darkMode })}
          >
            前往選購
          </Button>
          <FavoriteButton
            user={user}
            endpoint={favoriteEndpoint}
            isFavoriteInit={isFavorite}
            darkMode={darkMode}
          />
        </div>
      </div>
    </section>
  );
};

ProductAction.propTypes = {
  searchMode: PropTypes.shape({}),
  product: PropTypes.shape({
    skus: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
    started_at: PropTypes.string.isRequired,
    ended_at: PropTypes.string.isRequired
  }).isRequired,
  favoriteEndpoint: PropTypes.string.isRequired,
  isFavorite: PropTypes.bool.isRequired,
  user: PropTypes.shape({}),
  coupon: PropTypes.shape({
    vip_only: PropTypes.bool
  }),
  isHybrid: PropTypes.bool.isRequired,
  fundraisingMode: PropTypes.bool.isRequired
};

ProductAction.defaultProps = {
  user: null,
  coupon: null
};

export default ProductAction;
